/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import { Container, Card, FormControl, InputLabel, Checkbox, FormHelperText, Grid } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import SearchNotFound from '../../../SearchNotFound';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles';
import services from '../Services';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import dayjs from 'dayjs';

var screenCode = "AVAILABILITYAGAINSTREQUIREMENT"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'SKUCode',
        numeric: false,
        disablePadding: false,
        label: 'SKU Code',
        align: "left"
    },
    {
        id: 'SKUDescription',
        numeric: true,
        disablePadding: false,
        label: 'SKU Description',
        align: "left"
    },
    {
        id: 'AvailabilityForecasting',
        numeric: true,
        disablePadding: false,
        label: 'Availability Forecasting',
        align: "right"
    },
    {
        id: 'DemandForecasting',
        numeric: true,
        disablePadding: false,
        label: 'Demand Forecasting',
        align: "right"
    }

];
function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

export default function AvailabilityAgainstRequirement(props) {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);

    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('cropForecastdate');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const onKeyDown = (e) => {
        e.preventDefault();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [product, setProduct] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [cropAvailability, setCropAvailability] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);
    const [surplusDate, setSurplusDate] = useState(new Date());

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, cropAvailability.length - page * rowsPerPage);

    const getMondayOfCurrentWeek = () => {
        const today = dayjs();
        const dayOfWeek = today.day();
        const monday = dayOfWeek === 0 ? today.subtract(6, 'day') : today.subtract(dayOfWeek - 1, 'day');
        return monday;
    };

    const [fromDate, setFromDate] = useState(getMondayOfCurrentWeek());

    const getSundayOfCurrentWeek = () => {
        const today = dayjs();
        const dayOfWeek = today.day();
        const sunday = dayOfWeek === 0 ? today : today.add(7 - dayOfWeek, 'day');
        return sunday;
    };

    const [toDate, setToDate] = useState(getSundayOfCurrentWeek());

    const [currentSunday, setCurrentSunday] = useState(getSundayOfCurrentWeek());

    const shouldDisableDate = (date) => {
        const day = date.getDay();
        const today = new Date();
        return day !== 1;
    };

    const shouldDisableDateOne = (date) => {
        const day = dayjs(date).day();
        const today = dayjs();
        const isCurrentWeekSunday = dayjs(date).isSame(currentSunday, 'day');
        return day !== 0 && !isCurrentWeekSunday;
    };

    const handleDateChange = (newValue) => {
        setFromDate(newValue);
    };

    const handleDateChangeOne = (newValue) => {
        setToDate(newValue);
    };


    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: '',
        cropCategoryID: '',
        productID: '',
        fromDate: new Date(fromDate).toISOString(),
        toDate: new Date(toDate).toISOString(),
        isActive: true
    });
    const [totalValues, setTotalValues] = useState({
        totalDemand: 0,
        totalForecast: 0,

    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const cropAvailabilitySchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.array().required('Please select at least one Fresh collection center').min(1, 'Please select at least one Fresh collection center'),
        cropCategoryID: Yup.array().min(1, 'Please Select Product Category').required('Product Category Required'),
        productID: Yup.array().min(1, 'Please Select Product').required('Product Required'),
        toDate: Yup.date().min(1).min(1, 'Please Select End date').required('End date required'),
        fromDate: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required')
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        cropCategoryID: '',
        productID: '',
        toDate: '',
        fromDate: ''
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            cropCategoryID: selectedCategoryOptions,
            productID: selectedProductOptions,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
            isActive: formData.isActive
        },
        validationSchema: cropAvailabilitySchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        },
    });

    useEffect(() => {
        getPermissions()
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'AVAILABILITYAGAINSTREQUIREMENT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        })
        trackPromise(GetAllGroups());
        trackPromise(GetProductCategoties());
    }

    async function SubmitForm() {
        setPage(0);
        let model = {
            groupID: formik.values.groupID,
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            cropID: selectedProductOptions.map(x => x).join(',').toString(),
            fromDate: fromDate,
            toDate: toDate
        }
        var newRes = await services.GetAvailabilityAgainstRequirement(model)
        const forecast = newRes.forecast;
        const demand = newRes.demand;
        forecast.forEach(x => {
            let found = demand.find(y => y.productCode == x.productCode)
            if (found) {
                x.demand = found.availabilityForecasting
            }
            else {
                x.demand = 0
            }
        })
        const totalForecast = forecast.reduce((accumulator, current) => accumulator + current.availabilityForecasting, 0);
        const totalDemand = forecast.reduce((accumulator, current) => accumulator + current.demand, 0);
        setTotalValues({
            ...totalValues,
            totalForecast: totalForecast,
            totalDemand: totalDemand,
        })
        forecast.sort((a, b) => a.productDescription > b.productDescription ? 1 : -1);
        setCropAvailability(forecast);
        createDataForExcel(forecast);
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        if (!permissionList.isFactoryFilterEnabled) {
            setCropAvailability([]);
            setSelectedCategoryOptions([])
            setFromDate(getMondayOfCurrentWeek());
            setToDate(getSundayOfCurrentWeek());
            setSelectedProductOptions([]);
            setSelectedOptions([]);
        } else {
            setSelectedCategoryOptions([]);
            setFromDate(getMondayOfCurrentWeek());
            setToDate(getSundayOfCurrentWeek());
            setSelectedOptions([]);
            setSelectedProductOptions([]);
        }
    }

    useEffect(() => {
        trackPromise(GetProductCategoties());
        trackPromise(GetAllGroups());
        trackPromise(GetSurplusDateByProductID());
    }, []);

    useEffect(() => {
        trackPromise(GetProductDetails());
    }, [selectedCategoryOptions]);

    useEffect(() => {
        trackPromise(GetSurplusDateByProductID());
    }, [formik.values.productID]);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setCropAvailability([]);
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setCropAvailability([]);
    }, [formik.values.cropCategoryID]);

    useEffect(() => {
        setCropAvailability([]);
    }, [formik.values.productID]);

    useEffect(() => {
        setCropAvailability([]);
    }, [toDate]);

    useEffect(() => {
        setCropAvailability([]);
    }, [fromDate]);

    useEffect(() => {
        setCropAvailability([]);
    }, [selectedOptions]);

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptions,
            cropCategoryID: selectedCategoryOptions,
            productID: selectedProductOptions
        })
    }, [selectedOptions, selectedCategoryOptions, selectedProductOptions]);

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [factory]);

    useEffect(() => {
        setCropAvailability([]);
    }, [selectedCategoryOptions])

    useEffect(() => {
        setCropAvailability([]);
    }, [selectedProductOptions])

    useEffect(() => {
        if (selectedOptions.length > 0 && selectedCategoryOptions.length > 0) {
            trackPromise(GetProductDetails())
        }
    }, [selectedCategoryOptions, selectedOptions])

    useEffect(() => {
        if (selectedOptions.length == 0) {
            setProductcatogery([])
        } else {
            trackPromise(GetProductCategoties())
        }
    }, [selectedOptions])

    async function GetProductCategoties() {
        var res = await services.GetProductCategoties()
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productCategoryName, value: res[i].productCategoryID })
            }
            setProductcatogery(newOptionArray);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(
            selectedOptions.map(x => x).join(','),
            selectedCategoryOptions.map(x => x).join(",")
        )
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productName, value: res[i].productID })
            }
            setProduct(newOptionArray);
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setFactory(newOptionArray);
        }
    }

    async function GetSurplusDateByProductID() {
        var res = await services.GetSurplusDateByProductID(formik.values.productID)
        if (res != null) {
            setSurplusDate(res);
        }
    }

    async function createFile() {
        var file = await createDataForExcel(cropAvailability);
        var settings = {
            sheetName: 'AvailabilityAgainstTheRequirement',
            fileName: 'AvailabilityAgainstTheRequirement',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'AvailabilityAgainstRequirement',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(selectedOptions.length === factory.length ? [] : factory.map((option) => option.value));
        } else {
            setSelectedOptions(value);
        }
    };

    const handleSelectCategoryChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedCategoryOptions(selectedCategoryOptions.length === productcatogery.length ? [] : productcatogery.map((option) => option.value));
        } else {
            setSelectedCategoryOptions(value);
        }
    };

    const handleSelectProductChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedProductOptions(selectedProductOptions.length === product.length ? [] : product.map((option) => option.value));
        } else {
            setSelectedProductOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearCategorySelection = () => {
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearProductSelection = () => {
        setSelectedProductOptions([]);
    };

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'SKU Code': x.productCode,
                    'SKU Description': x.productDescription,
                    'Availability Forecasting': x.availabilityForecasting == 0 ? '-' : parseFloat(x.availabilityForecasting).toFixed(2),
                    'Demand Forecasting': x.demand == 0 ? '-' : parseFloat(x.demand).toFixed(2)
                }
                res.push(vr);
            });
            var vr = {
                'SKU Code': 'Total',
                'Availability Forecasting': totalValues.totalForecast == 0 ? '-' : parseFloat(totalValues.totalForecast).toFixed(2),
                'Demand Forecasting': totalValues.totalDemand == 0 ? '-' : parseFloat(totalValues.totalDemand).toFixed(2)
            }
            res.push(vr);
        }
        return res;
    }

    function getSelectedDropdownValuesForReport() {
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = factory.find(y => x === y.value).label
            facName.push(fildered)
        });

        const categoryName = [];
        selectedCategoryOptions.forEach(x => {
            const filterCategory = productcatogery.find(y => x === y.value).label
            categoryName.push(filterCategory);
        })

        const productName = [];
        selectedProductOptions.forEach(x => {
            const filterProduct = product.find(y => x === y.value).label
            productName.push(filterProduct);
        })

        let groups = group.find(x => x.groupID == formik.values.groupID)
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: groups.groupName,
            operationEntityID: facName.length == 0 ? 'All Fresh Collection Centers' : facName,
            cropCategoryID: categoryName.map(x => x).join(','),
            productID: productName.map(x => x).join(',')
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = factory.find((entity) => entity.value === selected[0]);
            return option ? option.label : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? option.label : null;
                } else {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? option.label : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderCategorySelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = productcatogery.find((entity) => entity.value === selected[0]);
            return option ? option.label : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? option.label : null;
                } else {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? option.label : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderProductSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = product.find((entity) => entity.value === selected[0]);
            return option ? option.label : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = product.find((entity) => entity.value === value);
                    return option ? option.label : null;
                } else {
                    const option = product.find((entity) => entity.value === value);
                    return option ? option.label : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Availability against the Requirement - Forecasting |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/availabilityAgainstRequirement"}
                        btname="Add"
                        pageName="Availability against the Requirement - Forecasting"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center *"
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedOptions.length === factory.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {factory.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>

                                    <FormControl fullWidth error={Boolean(touched.cropCategoryID && errors.cropCategoryID)}>
                                        <InputLabel id="multi-select-label">Product Category *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedCategoryOptions}
                                            onChange={handleSelectCategoryChange}
                                            label="Product Category "
                                            disabled={selectedOptions.length == 0}
                                            renderValue={(selected) => renderCategorySelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedCategoryOptions.length === productcatogery.length} color="primary" />
                                                All Product Category
                                            </MenuItem>
                                            {productcatogery.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedCategoryOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.cropCategoryID && errors.cropCategoryID && (
                                            <FormHelperText>{errors.cropCategoryID}</FormHelperText>
                                        )}
                                        {selectedCategoryOptions.length > 0 && (
                                            <IconButton onClick={handleClearCategorySelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <FormControl fullWidth error={Boolean(touched.productID && errors.productID)}>
                                        <InputLabel id="multi-select-label">Product * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedProductOptions}
                                            onChange={handleSelectProductChange}
                                            label="Product"
                                            disabled={selectedCategoryOptions.length == 0}
                                            renderValue={(selected) => renderProductSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedProductOptions.length === product.length} color="primary" />
                                                All Products
                                            </MenuItem>
                                            {product.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedProductOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.productID && errors.productID && (
                                            <FormHelperText>{errors.productID}</FormHelperText>
                                        )}
                                        {selectedProductOptions.length > 0 && (
                                            <IconButton onClick={handleClearProductSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select Start Date *"
                                            value={fromDate}
                                            onChange={handleDateChange}
                                            shouldDisableDate={shouldDisableDate}
                                            renderInput={(params) => (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...getFieldProps('fromDate')}
                                                    onKeyDown={onKeyDown}
                                                    error={Boolean(touched.fromDate && errors.fromDate)}
                                                    helperText={touched.fromDate && errors.fromDate}
                                                    {...params}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select End Date"
                                            value={toDate}
                                            onChange={handleDateChangeOne}
                                            shouldDisableDate={shouldDisableDateOne}
                                            minDate={fromDate}
                                            renderInput={(params) => (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...getFieldProps('toDate')}
                                                    onKeyDown={onKeyDown}
                                                    error={Boolean(touched.toDate && errors.toDate)}
                                                    helperText={touched.toDate && errors.toDate}
                                                    {...params}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Grid><Button
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                        > Clear</Button>
                                        </Grid>
                                        <Grid>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >Search</Button>
                                        </Grid>
                                    </Stack>
                                </Stack>
                            </Stack>
                            <br />
                            <>
                                {cropAvailability.length != 0 ? (
                                    <>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center', width: '100rem' }}>
                                                <Paper className={classes.paper}>
                                                    <TableContainer>
                                                        <Table
                                                            className={classes.table}
                                                            aria-labelledby="tableTitle"
                                                            aria-label="enhanced table"
                                                        >
                                                            <EnhancedTableHead
                                                                classes={classes}
                                                                order={order}
                                                                orderBy={orderBy}
                                                                onRequestSort={handleRequestSort}
                                                                rowCount={cropAvailability.length}
                                                            />
                                                            <TableBody>
                                                                {stableSort(cropAvailability, getComparator(order, orderBy))
                                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                    .map((row, index) => {
                                                                        const labelId = `enhanced-table-checkbox-${index}`;
                                                                        return (
                                                                            <TableRow>
                                                                                <TableCell component="th" id={labelId} scope="row">{row.productCode}</TableCell>
                                                                                <TableCell >{row.productDescription}</TableCell>
                                                                                <TableCell align={'right'}>
                                                                                    {row.availabilityForecasting == 0 ? '-' : parseFloat(row.availabilityForecasting).toFixed(2)}
                                                                                </TableCell>
                                                                                <TableCell align={'right'}>
                                                                                    {row.demand == 0 ? '-' : parseFloat(row.demand).toFixed(2)}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        );
                                                                    })}
                                                            </TableBody>
                                                            <TableRow>
                                                                <TableCell colSpan={2} align={'left'} style={{ fontWeight: 'bold' }}>Total</TableCell>
                                                                <TableCell align={'right'} style={{ fontWeight: 'bold' }}>
                                                                    {totalValues.totalForecast == 0 ? '-' : parseFloat(totalValues.totalForecast).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                                <TableCell align={'right'} style={{ fontWeight: 'bold' }}>
                                                                    {totalValues.totalDemand == 0 ? '-' : parseFloat(totalValues.totalDemand).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                            </TableRow>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 10, 25]}
                                                        component="div"
                                                        count={cropAvailability.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                </Paper>
                                            </Card>
                                        </Stack>
                                    </>
                                ) : <SearchNotFound searchQuery="Availability against the Requirement - Forecasting" />}</>
                        </Form>
                    </FormikProvider>
                    {cropAvailability.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Availability against the Requirement - Forecasting"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    productList={cropAvailability}
                                    searchData={selectedSearchValues}
                                    totalValues={totalValues}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}